module.exports = __webpack_public_path__ + "img/journey-icon.919ae879.svg";